import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmVolumeX = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-llm-volume-x" data-icon="" {...props} ref={ref}><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="22" y1="9" x2="16" y2="15"/><line x1="16" y1="9" x2="22" y2="15"/></svg>);
});

IconLlmVolumeX.displayName = 'IconLlmVolumeX';
